import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuLayoutComponent } from "../menu-layout/menu-layout.component";
import { SideBarService } from '../../shared/services/common/side-bar.service';
import { AppAuthService } from '../../shared/services/auth/auth.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
})
export class ContentLayoutComponent implements OnInit {
  //shwFilter: boolean = false;

  constructor(
    private sidebarService: SideBarService,
    public authService: AppAuthService
  ) {}

  ngOnInit() {}

  // openSidebar() {
  //   this.sidebarService.showSidebar();
  // }

  // loadFilter(){
  //   this.shwFilter = !this.shwFilter;
  // }

  // loadLogout(){
  //   this.authService.logoutUser();
  // }

  // showMenu() {
  //   this.sidebarService.showMenubar();
  // }
}
